export default __webpack_public_path__ + "static/media/chapter_1_stats.5c08649d.svg";